import api from "./axiosClient";

export const getFoodCategories = async (restaurantId) => {
    const res = await api.get("/food/food-categories", {
        params: { r_id: restaurantId },
    });
    return res.data;
};

export const getProducts = async (categoryId, restaurantId) => {

   const res = await api.get(`/food/products/${encodeURIComponent(restaurantId)}/${encodeURIComponent(categoryId)}`);

  const products = res.data || [];

  // Ensure every product has a stable `pid` property
  return products.map((p) => ({
    ...p,
    pid: p.pid ?? p.p_id ?? p.product_id ?? p.id,
  }));
};

export const saveOrder = async (data) => {
    const res = await api.post("/orders/createkot", data);
    return res.data;
};

export const updateKOT = async (kotId, data) => {
    const res = await api.put(`/orders/kots/${encodeURIComponent(kotId)}`, data);
    return res.data;
};

export const deleteKOT = async (kotId, restaurantId) => {
    const res = await api.delete(`/orders/kots/${encodeURIComponent(kotId)}/${encodeURIComponent(restaurantId)}`);
    return res.data;
};

export const voiceOrder = async (text) => {
  try {
    const res = await api.post("/voice-order", {
    //const res = await api.post("/ai-voice-order",{
      text,
    });
    return res.data;
  } catch (error) {
    console.error("Voice API error:", error);
    throw error;
  }
};

export const getExistingKOTs = async (seatingName, restaurantId) => {
    const res = await api.get(`/orders/kots/${encodeURIComponent(seatingName)}/${restaurantId}`);
    return res.data;
};

export const getAggregatedKOTs = async (seatingName, restaurantId) => {
    const res = await api.get(`/orders/kots/aggregate/${encodeURIComponent(seatingName)}/${restaurantId}`);
    return res.data;
};

export const getKOTConsole = async (restaurantId) => { 
  const res = await api.get(`/orders/kot-console/${encodeURIComponent(restaurantId)}`);
  return res.data;
}; 

export const getKOTDetail = async (kotId, restaurantId) => { 
  const res = await api.get(`/orders/kots/detail/${encodeURIComponent(kotId)}/${encodeURIComponent(restaurantId)}`); 
  return res.data;
}

export const cancelOrderKOT = async (kotId, restaurantId) => { 
  const res = await api.post(`/orders/kots/${encodeURIComponent(kotId)}/cancel`, { 
    restaurantId, 
  });
  return res.data;
}

export const shiftKOTToTable = async (kotId, data) => {
  const res = await api.post(`/orders/kots/${encodeURIComponent(kotId)}/shift`, data);
  return res.data;
}

export const shiftCompleteTableKOTs = async (data) => {
  const res = await api.post("/orders/kots/shift-table", data);
  return res.data;
}

export const generateBill = async (data) => {
    const res = await api.post("/bills/generate", data);
    return res.data;
};

export const getPendingBills = async (restaurantId) => {
  const res = await api.get(`/bills/pendingbills/${encodeURIComponent(restaurantId)}`);
  return res.data;
}

export const settleBill = async (data) => {
  const res = await api.post("/bills/settlebill", data);
  return res.data;
};

export const ungenerateBill = async (data) => {
  const res = await api.post("/bills/ungeneratebill", data);
  return res.data;
};
